import React, { useState } from 'react';
//import Button from 'react-bootstrap/Button';
import axios from 'axios';
import { Helmet } from "react-helmet";
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import './SignUp.css';
import config from '../includes/ConfigFile';


const SignUp = () => {
    const navigate = useNavigate();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [nameError, setNameError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [passwordError, setPasswordError] = useState('');

    const [submissionSuccess, setSubmissionSuccess] = useState(false);

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const collectData = async () => {
        // Clear previous error messages
        setNameError('');
        setEmailError('');
        setPasswordError('');

        // Validate name
        if (name.trim() === "") {
            setNameError('Name cannot be empty.');
            return;
        }

        // Validate email
        if (!validateEmail(email)) {
            setEmailError('Invalid email format.');
            return;
        }

        // Validate password and confirm password
        if (password !== confirmPassword) {
            setPasswordError('Passwords do not match.');
            return;
        }

        // Proceed with form submission if all validations pass

        // try {
           
        // } catch (error) {
        //     console.error("Error:", error.response ? error.response.data : error.message);
        // }

        try {


            const response = await axios.post(`${config.BASE_URL}/api/register`, {
                name,
                email,
                password
            });

            console.log(response.data); // Handle the success response
            // const response = await axios.post("http://localhost:8080/api/register", {
            //     name,
            //     email,
            //     password
            // });

            // Check if the insert was successful and update the state
            if (response.data.message) { // Adjust response handling based on your API's response structure
                setSubmissionSuccess(true);
                resetForm();
                 setTimeout(() => {
                    navigate('/signIn');
                }, 2000);
            } else {
                setSubmissionSuccess(false);
                alert(response.data.message || 'Registration failed.');
            }
        } catch (error) {
            console.error('Error during registration:', error);
            setSubmissionSuccess(false);
            alert('An error occurred. Please try again later.');
        }
    };

    const resetForm = () => {
        setName("");
        setEmail("");
        setPassword("");
        setConfirmPassword("");
    };

    return (
        <>
        <Helmet>
                <meta charSet="utf-8" />
                <title>Register </title>
                <link rel="canonical" href="http://mysite.com/example" />
                <meta name="description" content="Helmet application" />
        </Helmet>
            <Container className="signup-container">
            <Row className="justify-content-center">
            <Col md={8} lg={6}>
            <Card className="signup-card">
            <Card.Body>
                <div className="text-center mb-4">
                    <h2 className="signup-title">Create Account</h2>
                    <p className="signup-subtitle">Join our community today!</p>
                </div>
                    

                        {submissionSuccess && (
                            <p className="bg-success text-white p-3 ms-6 gap-3">Registration successfully ! Redirecting to login...</p>
                        )}

                        <form>
                            <div className="form-floating mb-3">
                                <input className="form-control" value={name} onChange={(e) => setName(e.target.value)} type="text" placeholder="Enter Name" />
                                <label htmlFor="name">Name</label>
                                {nameError && <div className="text-danger">{nameError}</div>}
                            </div>
                            <div className="form-floating mb-3">
                                <input className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="Enter Email" />
                                <label htmlFor="email">Email</label>
                                {emailError && <div className="text-danger">{emailError}</div>}
                            </div>
                            <div className="form-floating mb-3">
                                <input className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} type="password" placeholder="Enter Password" />
                                <label htmlFor="password">Password</label>
                            </div>
                            <div className="form-floating mb-3">
                                <input className="form-control" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} type="password" placeholder="Confirm Password" />
                                <label htmlFor="confirmPassword">Confirm Password</label>
                                {passwordError && <div className="text-danger">{passwordError}</div>}
                            </div>
                            <div className="form-floating">
                                <button onClick={collectData} type="button" className="btn btn-primary">Sign Up</button>
                            </div>
                        </form>
                    
                    </Card.Body>
                    </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default SignUp;
